require('/ui/components/taskflow/taskflow.module.scss.module.css');

export const desktopLayoutContainer = "_desktop-layout-container_1tskm_1";
export const header = "_header_1tskm_1";
export const breadcrumbsPadding = "_breadcrumbs-padding_1tskm_1";
export const logoPadding = "_logo-padding_1tskm_1";
export const mainPart = "_main-part_1tskm_1";
export const verticalScroll = "_vertical-scroll_1tskm_1";
export const leftNav = "_left-nav_1tskm_1";
export const contentArea = "_content-area_1tskm_1";
export const compactLayout = "_compact-layout_1tskm_1";
export const navHeader = "_nav-header_1tskm_1";
export const partition = "_partition_1tskm_1";
export const stepper = "_stepper_1tskm_1";
export const ctas = "_ctas_1tskm_1";
export const buttonLabel = "_button-label_1tskm_1";
export const padding = "_padding_1tskm_1";
